/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SingleHistogramSeriesViewBucket
 */
export interface SingleHistogramSeriesViewBucket {
    /**
     * 
     * @type {number}
     * @memberof SingleHistogramSeriesViewBucket
     */
    bucketNo: number;
    /**
     * 
     * @type {number}
     * @memberof SingleHistogramSeriesViewBucket
     */
    count: number;
}

/**
 * Check if a given object implements the SingleHistogramSeriesViewBucket interface.
 */
export function instanceOfSingleHistogramSeriesViewBucket(value: object): value is SingleHistogramSeriesViewBucket {
    if (!('bucketNo' in value) || value['bucketNo'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function SingleHistogramSeriesViewBucketFromJSON(json: any): SingleHistogramSeriesViewBucket {
    return SingleHistogramSeriesViewBucketFromJSONTyped(json, false);
}

export function SingleHistogramSeriesViewBucketFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleHistogramSeriesViewBucket {
    if (json == null) {
        return json;
    }
    return {
        
        'bucketNo': json['bucketNo'],
        'count': json['count'],
    };
}

export function SingleHistogramSeriesViewBucketToJSON(value?: SingleHistogramSeriesViewBucket | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'bucketNo': value['bucketNo'],
        'count': value['count'],
    };
}

